import burgerSet from "../../assets/images/burgerset.svg";
import points from "../../assets/images/points.svg";

// Styles
import "./styles.scss";

function HeaderInfoBox(props) {
  return (
    <div className="info-section">
      <div className="col-style">
        <img src={burgerSet} alt="" className="info-icon" />
        <div className="text">
          {props.served} <span>Served</span>
        </div>
      </div>
      <div className="divider" />
      <div className="col-style">
        <img src={points} alt="" className="info-icon" />
        <div className="text">
          {props.points} <span>Points</span>
        </div>
      </div>
    </div>
  );
}

export default HeaderInfoBox;
